import { PageHero, CtaBlock, Btn, BrowserFrame, TextLink } from "@/components/site/Ui";
import { Clip, Reveal } from "@/components/site/Motion";
import Split from "@/components/site/Split";
import { Methode } from "@/components/home/Sections";
import { projects } from "@/content/site";
import { useSeo } from "@/lib/seo";

const included = [
  { t: "Design sur mesure", d: "Construit à partir de votre identité, pas d'un modèle." },
  { t: "Pensé mobile", d: "La plupart des recherches locales se font sur téléphone." },
  { t: "Rapide", d: "Images optimisées, code léger, navigation fluide." },
  { t: "Bases SEO", d: "Titres, métadonnées, structure et données structurées." },
  { t: "Appel et contact", d: "Boutons d'appel, formulaire, itinéraire." },
  { t: "Réservation", d: "Rendez-vous ou table en ligne, arrhes, agenda (formule Réservation)." },
];

export default function CreationSites() {
  const p = projects[2];
  useSeo({
    title: "Création de site internet à Toulouse — sites vitrines sur mesure",
    description: "Création de site internet à Toulouse pour restaurants, instituts de beauté, commerces et artisans : sur mesure, mobile, rapide, avec réservation en ligne.",
    path: "/expertises/creation-site-internet",
  });
  return (
    <>
      <PageHero testid="creation-hero" label="Création de sites internet" lines={["Un site à votre image,", "pensé pour être trouvé."]}
        intro="Restaurants, instituts, coiffeurs, boutiques, artisans : je crée des sites vitrines qui donnent envie d'appeler ou de réserver.">
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Btn to="/diagnostic" track="cta_diagnostic" testid="creation-cta">Demander un diagnostic digital</Btn>
          <Btn to="/tarifs" variant="outline" testid="creation-tarifs">Voir les tarifs</Btn>
        </div>
      </PageHero>
      <section className="wrap pb-20">
        <Clip><BrowserFrame src={p.shots.s1} alt={`Section carte du site ${p.name}`} label={p.name} /></Clip>
        <p className="mt-3 font-mono text-[13px] text-mute">Projet : {p.name} — <TextLink to={`/realisations/${p.slug}`} className="!text-[13px]">voir l'étude de cas</TextLink></p>
      </section>
      <section className="wrap pb-20" data-testid="creation-included">
        <h2 className="display h-lg mb-12 max-w-3xl">Ce que comprend votre site.</h2>
        <div className="grid gap-px bg-ink/15 sm:grid-cols-2 lg:grid-cols-3">
          {included.map((x, i) => (
            <Reveal key={x.t} delay={(i % 3) * 0.06} className="bg-ivory p-6 md:p-8">
              <p className="font-mono text-[13px] text-mute">0{i + 1}</p>
              <h3 className="display mt-3 text-[1.7rem] leading-tight">{x.t}</h3>
              <p className="mt-2 leading-relaxed text-mute">{x.d}</p>
            </Reveal>
          ))}
        </div>
      </section>
      <Split label="Par secteur" title="Restaurant, institut de beauté, commerce indépendant.">
        <p><strong className="text-ink">Restaurants :</strong> carte, horaires, accès, appel ou réservation.</p>
        <p><strong className="text-ink">Instituts, spas, coiffeurs :</strong> soins, tarifs, rendez-vous en ligne, arrhes.</p>
        <p><strong className="text-ink">Boutiques et artisans :</strong> offre, réalisations, zone, demande de devis.</p>
      </Split>
      <Methode />
      <CtaBlock />
    </>
  );
}
